import { render, staticRenderFns } from "./lecturerResource.vue?vue&type=template&id=0b7b40a8&scoped=true"
import script from "./lecturerResource.vue?vue&type=script&lang=js"
export * from "./lecturerResource.vue?vue&type=script&lang=js"
import style0 from "./lecturerResource.vue?vue&type=style&index=0&id=0b7b40a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b40a8",
  null
  
)

export default component.exports